// src/components/MessageInput.js
import React from 'react';
import {Box, CircularProgress, IconButton, TextField} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const MessageInput = ({inputValue, setInputValue, handleSendMessage, isWaitingResponse, conversationEnabled}) => {
    return (
        <Box sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            alignItems: 'center',
            padding: '8px 16px',
            borderTop: '1px solid #10101075',
            backgroundColor: '#88888836',
            zIndex: 10, // Ensure it stays above other content
        }}>
            <TextField
                placeholder="הקלד כאן..."
                variant="outlined"
                size="small"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        handleSendMessage();
                    }
                }}
                disabled={isWaitingResponse || !conversationEnabled} // Disable input when waiting for response
                sx={{
                    flexGrow: 1,
                    marginLeft: '8px', // Swap marginRight to marginLeft for RTL
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'rgba(170,170,170,0)', // Default border color
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(170,170,170,0)', // Border color on hover
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'rgba(170,170,170,0)', // Border color when focused
                        },
                        color: '#aaaaaa', // Text color inside the input field
                    },
                    '& input': {
                        color: '#aaaaaa', // Ensure input text is white
                    },
                    '& .MuiInputLabel-root': {
                        color: '#aaaaaa', // Label color (if you have a label)
                    },
                    direction: 'rtl', // Set RTL direction for input field
                }}
            />


            {isWaitingResponse ? (
                    <CircularProgress size={24} sx={{color: '#aaaaaa', marginLeft: '8px'}}/>
                ) :
                (<IconButton
                    color="primary"
                    onClick={handleSendMessage}
                    disabled={isWaitingResponse || !conversationEnabled} // Disable button when waiting for response
                >
                    <SendIcon
                        sx={{
                            transform: 'rotate(180deg)', // Rotate the icon 180 degrees
                        }}
                    />
                </IconButton>)
            }
        </Box>
    );
};

export default MessageInput;
